import React, {useContext, useEffect} from 'react'
import {Form, Input} from "antd";
import {OfferContext} from "../../../context/OfferContext";


const OfferTerm = ({rowIndex, record}) => {
    const [form] = Form.useForm()
    const {materialInformation} = useContext(OfferContext)
    const [materials, setMaterials] = materialInformation

    useEffect(() => {
        form.setFieldsValue({
            [`${rowIndex}-deadline`]: record.deadline || ''
        })
    }, [rowIndex, record])

    const handleDateChange = (list) => {
        let mockContext = [...materials]
        mockContext[rowIndex].deadline = list[`${rowIndex}-deadline`]
        setMaterials(mockContext)
    }

    return(
        <React.Fragment>
            <Form form={form}>
                <Form.Item name={`${rowIndex}-deadline`}>
                    <Input style={{maxWidth: '100px'}} onChange={() => handleDateChange(form.getFieldsValue())} />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferTerm